import clubService from '../services/clubService'
import champsService from '../services/champsService'
import managementService from '../services/managementService'
import router from '../router'
import { isEmpty, clone, sortBy } from 'lodash'
import store from './index'

const defaultState = {
  clubCode: null,
  clubInfo: null,
  clubMembers: null,
  clubMembersCount: 0,
  clubAchievements: null,
  clubStartsItems: null,
  clubStartsCount: 0,
  clubStartsInternalCount: 0,
  clubStartsExternalCount: 0,
  clubLeaders: null,
  clubActivities: null,
  clubActivitiesCount: 0,
  clubFilters: {},
  infoUpdateTrigger: true,
  membersUpdateTrigger: +new Date(),
  requestsCount: 0,
  membersLinkAvailable: true
}
const state = clone(defaultState)

const mutations = {
  clearClub (state) {
    for (const key in defaultState) {
      state[key] = defaultState[key]
    }
  },
  saveClubMembers (state, data) {
    state.clubMembers = data.items
    state.clubMembersCount = data.totalCount
    if (state.clubInfo) {
      state.clubInfo.membersCount = data.totalCount
    }
  },
  saveClubInfo (state, { code, data }) {
    if (!data) {
      router.replace({
        name: 'Home'
      })
    }
    state.clubCode = code
    state.clubInfo = data
  },
  saveClubAchievements (state, { data }) {
    state.clubAchievements = data
  },
  saveClubStarts (state, { data }) {
    state.clubStartsInternalCount = data.InternalChampsCount
    state.clubStartsExternalCount = data.ExternalChampsCount
    state.clubStartsCount = data.TotalChampsCount
    state.clubStartsItems = data.NextStarts
  },
  resetClubStarts (state) {
    state.clubStartsInternalCount = 0
    state.clubStartsExternalCount = 0
    state.clubStartsCount = 0
    state.clubStartsItems = null
  },
  saveClubLeaders (state, { items }) {
    state.clubLeaders = items
  },
  saveClubActivities (state, { items }) {
    state.clubActivities = items
    let count = 0
    for (let i = 0, l = items.length; i < l; i++) {
      count += items[i].activitiesCount
    }
    state.clubActivitiesCount = count
  },
  saveFilters (state, { data }) {
    state.clubFilters = data
  },
  triggerInfoUpdate (state) {
    state.infoUpdateTrigger = true
  },
  triggerMembersUpdate (state) {
    state.membersUpdateTrigger += 1
    state.membersCode = null
    state.leadersCode = null
    state.activitiesCode = null
    state.filtersCode = null
    store.state.clubRating.clubRatingSettings = {}
  },
  saveRequestsCount (state, count) {
    state.requestsCount = count
  },
  setMembersLinkAvailable (state, data) {
    state.membersLinkAvailable = data
  }
}

const getters = {
  clubCityFilterValues (state) {
    const result = [{
      id: 'any',
      name: 'Любой'
    }]
    let values = state.clubFilters.cities

    if (!values) {
      return result
    }

    values = sortBy(values, (o) => o.toLowerCase())

    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      result.push({
        id: option,
        name: option
      })
    }
    return result
  },
  clubDisciplineFilterValues (state) {
    const result = []
    const values = state.clubFilters.disciplines

    if (!values) {
      return result
    }
    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      const name = option.value === 'Велосипедный спорт' ? 'Велозаезд' : option.value

      result.push({
        id: option.code,
        name: name
      })
    }
    return result
  },
  clubGenderFilterValues (state) {
    const result = [{
      id: 'any',
      name: 'Любой'
    }]
    const values = state.clubFilters.genders

    if (!values || !values.length) {
      return result
    }

    for (let i = 0; i < values.length; i++) {
      const option = values[i]
      result.push({
        id: option,
        name: option === 'male' ? 'Мужской' : 'Женский'
      })
    }
    return result
  }
}

const actions = {
  createClub ({ state }, data) {
    return clubService.createClub(data)
  },
  editClub ({ state }, data) {
    return clubService.editClub(data)
  },
  checkNameIsExist ({ state }, { name }) {
    return clubService.checkNameIsExist(name)
  },
  getClubInfo ({ state, commit }, code) {
    if (!state.infoUpdateTrigger &&
      ((state.clubCode === code && state.clubInfo) || state.clubLoading)
    ) {
      return null
    }
    state.clubLoading = true
    return clubService.getClubInfo(code)
      .then(response => {
        commit('saveClubInfo', {
          code: code,
          data: response.data
        })
        state.infoUpdateTrigger = false
        state.clubLoading = false
      })
      .catch((error) => {
        if (error.message !== 'canceled') {
          state.clubLoading = false
        }
      })
  },
  getClubMembers ({ commit }, data) {
    if (state.membersCode === data.code && state.clubMembers) {
      return
    }
    state.membersCode = data.code
    return clubService.getClubMembers(data)
      .then(response => {
        commit('saveClubMembers', {
          items: response.data.items,
          totalCount: response.data.totalCount
        })
      })
      .catch(() => {
        commit('saveClubMembers', {
          items: [],
          totalCount: 0
        })
      })
  },
  setClubBackground ({ commit }, data) {
    return clubService.setClubBackground(data)
  },
  joinClub ({ state }, data) {
    return clubService.joinClub(data)
  },
  leaveClub ({ state }, data) {
    return clubService.leaveClub(data)
  },
  getClubLeaders ({ state, commit }, { clubCode }) {
    if (state.leadersCode === clubCode && state.clubLeaders) {
      return
    }
    state.leadersCode = clubCode
    return champsService.getClubLeaders({ clubCode })
      .then((response) => {
        commit('saveClubLeaders', {
          items: response.data
        })
      })
      .catch(() => {
        commit('saveClubLeaders', {
          items: {}
        })
      })
  },
  getClubActivities ({ commit }, clubCode) {
    if (state.activitiesCode === clubCode && state.clubActivities) {
      return
    }
    state.activitiesCode = clubCode
    return champsService.getClubTrainingCount(clubCode)
      .then(response => {
        commit('saveClubActivities', {
          items: response.data
        })
      })
      .catch(() => {
        commit('saveClubActivities', {
          items: []
        })
      })
  },
  getClubFilters ({ commit }, clubCode) {
    if (state.filtersCode === clubCode && !isEmpty(state.clubFilters)) {
      return
    }
    state.filtersCode = clubCode
    state.clubFilters = {}
    champsService.getTrainingFilters({ clubCode, withNoActivities: true })
      .then((response) => {
        commit('saveFilters', {
          data: response.data
        })
      })
  },
  getRequestsCount ({ commit }, clubCode) {
    managementService.getRequestsCount(clubCode)
      .then(response => {
        commit('saveRequestsCount', response.data.totalCount)
      })
  },
  getClubAchievements ({ state, commit }, { clubId }) {
    if (state.achievementsId === clubId && state.clubAchievements) {
      return
    }
    state.clubAchievements = null
    state.achievementsId = clubId
    return champsService.getAchievements({ clubId })
      .then(response => {
        commit('saveClubAchievements', {
          data: response.data.Achievements
        })
      })
  },
  getClubStarts ({ state, commit }, { clubId }) {
    if (state.startsId === clubId && state.clubStartsItems) {
      return
    }
    state.clubStartsItems = null
    state.startsId = clubId
    return champsService.getStarts({ clubId })
      .then(response => {
        commit('saveClubStarts', {
          data: response.data
        })
      })
  }
}

export const club = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
